export const doNotModifyCodeAbove =
    "// do not modify code on this line or above\n";

export const doNotModifyCodeBelow =
    "// do not modify code on this line or below\n";
export const tabSpace = "    ";
export const SOLVE_YOURSELF_ID = 999;
export const MODULE_COMPLETE_ID = 1000;
export const postLevel1ModuleCompleteColor = "#1C32FF";
export const level1ModuleCompleteColor = "#F20151";

export const nextStepsLinks = [
    {
        href: "/ask",
        text: "Ask a Question to the Triality Community",
    },
    {
        href: "/questions",
        text: "Answer some questions on Triality",
    },
    {
        href: "https://github.com/starknet-edu",
        text: "Check out Starknet edu for more education in all things Starknet and Cairo ",
    },
    {
        href: "https://www.onlydust.xyz/",
        text: "Ready to contribute and get paid? Check out the OnlyDust contributor page for current projects",
    },
];
